import { toast } from '@webapp/components/Notification'
import { getMessageFromError } from '@webapp/core/utils/errors/getMessageFromError'
import { useProcurifyIntl } from '@webapp/hooks'
import { type CatalogPermissionSecondaryCategoryConfig } from '@webapp/modules/purchasing/entities/CatalogPermissionSecondaryCategoryConfig'
import messages from './messages'
import { useAssignUsersToSecondaryCategoryModel } from '../../models'

interface UseAssignUsersToSecondaryCategoryPresenterOptions {
  secondaryCategory: CatalogPermissionSecondaryCategoryConfig
  onSuccess?: () => void
}

export const useAssignUsersToSecondaryCategoryPresenter = ({
  secondaryCategory,
  onSuccess,
}: UseAssignUsersToSecondaryCategoryPresenterOptions) => {
  const intl = useProcurifyIntl()
  const { mutate, isLoading, isOptionsLoading, userOptions } =
    useAssignUsersToSecondaryCategoryModel()

  const handleSave = (selectedUserIds: number[]) => {
    mutate(
      { secondaryCategoryId: secondaryCategory.id, userIds: selectedUserIds },
      {
        onSuccess: () => {
          toast.success({
            title: intl.formatMessage(messages.successTitle),
            children: intl.formatMessage(messages.successMessage),
          })
          onSuccess?.()
        },
        onError: (error) => {
          toast.error({
            title: intl.formatMessage(messages.errorTitle),
            children:
              getMessageFromError(error) ||
              intl.formatMessage(messages.errorMessage),
          })
        },
      }
    )
  }

  return {
    userOptions,
    isSaving: isLoading,
    isLoading: isOptionsLoading,
    handleSave,
  }
}
